import * as index from './index';
index.AIAssistView.Inject(index.AssistThinking);
export * from './index';
